import { useCallback, useState } from 'react';

/**
 * Where a menu should portal to: the fullscreen element while one is up, since the
 * browser paints nothing outside it, and `document.body` otherwise.
 *
 * Read when the menu opens rather than tracked — the chart does not know which of
 * its ancestors went fullscreen (the map does it to its own surface), and the menu
 * only needs the answer at the moment it is about to show.
 */
export function useFullscreenPortal() {
  const [container, setContainer] = useState<Element | null>(null);

  const onOpenChange = useCallback((open: boolean) => {
    if (open) setContainer(document.fullscreenElement);
  }, []);

  return { container: container ?? undefined, onOpenChange };
}
